import React from "react";
import styles from "./PropertyCard.module.scss";
import ShareIcon from "@mui/icons-material/Share";

interface Property {
  id: string;
  direccion: string;
  precio: number;
  habitaciones: number;
  banos: number;
  terreno: string;
  imagenesURLs: string[];
}

interface PropertyCardProps {
  property: Property;
  clickFn: (propertyId:string) => void;
}

export const PropertyCard: React.FC<PropertyCardProps> = ({
  property,
  clickFn,
}) => {
  return (
    <div className={styles.card} onClick={()=>clickFn(property.id)}>
      <img src={property.imagenesURLs[0]} alt="Property" />
      <h3>{property.direccion}</h3>
      <p className={styles.price}>{property.precio.toLocaleString("en")}</p>
      <p>
        {property.habitaciones} 🛏️ | {property.banos} 🛁 | {property.terreno} m²
      </p>
      <div className={styles.agentInfo}>
        <p>👩‍💼 Martha Sosa </p>
        <ShareIcon className={styles.icons} />
      </div>
    </div>
  );
};
